// client/src/components/plataforma/siteInstitucional/LoadingSkeleton.js
import React from 'react';

const LoadingSkeleton = () => (
    <div className="animate-pulse p-6 bg-white rounded-lg shadow-md">
        <div className="h-12 bg-gray-200 rounded-md mb-6 w-3/4"></div>
        
        <div className="form-section mb-8">
            <div className="h-8 w-1/4 bg-gray-300 rounded mb-4"></div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {[...Array(6)].map((_, i) => (
                    <div key={i} className="h-10 bg-gray-200 rounded"></div>
                ))}
            </div>
        </div>
        
        <div className="form-section">
            <div className="flex justify-between items-center mb-4">
                <div className="h-8 w-1/4 bg-gray-300 rounded"></div>
                <div className="h-10 w-24 bg-gray-200 rounded"></div>
            </div>
            
            {[...Array(3)].map((_, i) => (
                <div key={i} className="border rounded p-4 mb-4 bg-gray-100 flex items-start gap-4">
                    <div className="h-5 w-5 bg-gray-300 rounded-full mt-2"></div>
                    <div className="flex-grow">
                        <div className="h-6 w-2/3 bg-gray-200 rounded mb-2"></div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                            {[...Array(4)].map((_, j) => (
                                <div key={j} className="h-9 bg-gray-200 rounded"></div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default LoadingSkeleton;